import { render, staticRenderFns } from "./MobileList.vue?vue&type=template&id=0b791b11"
import script from "./MobileList.vue?vue&type=script&lang=js"
export * from "./MobileList.vue?vue&type=script&lang=js"
import style0 from "./MobileList.vue?vue&type=style&index=0&id=0b791b11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports